import { render, staticRenderFns } from "./AttrCoordinate.vue?vue&type=template&id=91818eb8&"
import script from "./AttrCoordinate.vue?vue&type=script&lang=js&"
export * from "./AttrCoordinate.vue?vue&type=script&lang=js&"
import style0 from "./AttrCoordinate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports